module.exports = __webpack_public_path__ + "static/media/Community.24242614.svg";